import { render } from "./AddReceipt.vue?vue&type=template&id=cf44e39a"
import script from "./AddReceipt.vue?vue&type=script&lang=js"
export * from "./AddReceipt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__